import { useState } from "react";
import "./App.css";
import Header from "./components/header/Header";
import Main from "./Main";
import { AuthContextProvider } from "./utils/AuthContext";
import Footer from "./components/footer/footer";

function App() {

    const [nickname, setNickname] = useState("");

    return (
        <AuthContextProvider>
            <div className="App">
                <Header nickname={nickname}/>
                <Main setNickname={setNickname}/>
                <Footer />
            </div>
        </AuthContextProvider>
    );
}

export default App;
